<template>
  <div class="report-page">
    <iframe
      :srcdoc="reportHtml"
      class="report-frame"
      title="SEQ Report"
    ></iframe>
  </div>
</template>

<script>
import reportHtml from '@/assets/seq_report.html';

export default {
  name: 'Report1',
  data() {
    return {
      reportHtml
    };
  }
};
</script>

<style scoped>
.report-page {
  width: 100%;
  height: calc(100vh - 60px);
  margin: 0;
  padding: 0;
  background: #FAF7F2;
}

.report-frame {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
